import Access               from "dashboard/dist/Core/Access";
import Status               from "dashboard/dist/Core/Status";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";

// Types
import {
    ADMIN_LOADING,
    ADMIN_LIST, ADMIN_ELEM, ADMIN_CREATE,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    idds      : [],
    countries : [],
    provinces : {},
    sort      : {
        orderBy  : "createdTime",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate     = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.loginDate       = DateTime.formatIf(elem.lastLogin, "dashes");
    elem.loginDateTime   = DateTime.formatIf(elem.lastLogin, "dashesTime");
    elem.levelName       = Access.getName(elem.level);
    elem.statusName      = Status.getFemName(elem.status);
    elem.statusColor     = Status.getColor(elem.status);
    elem.statusClass     = Status.getTextClass(elem.status);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, ADMIN_LIST, ADMIN_ELEM, ADMIN_CREATE)) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case ADMIN_LOADING:
        return {
            ...state,
            loading   : true,
        };

    case ADMIN_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case ADMIN_ELEM:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            canEdit   : action.data.canEdit,
            elem      : parseElem(action.data.elem),
            idds      : action.data.idds,
            countries : action.data.countries,
            provinces : action.data.provinces,
        };

    case ADMIN_CREATE:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            idds      : action.data.idds,
            countries : action.data.countries,
            provinces : action.data.provinces,
        };

    default:
        return state;
    }
};

export default reducer;
